
import { FC, useState, useEffect } from 'react'
import { Routes, Route, BrowserRouter, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'
import LogoutListener from '../helper-functions/logoutLitsner'
import { VerifyOrgEmailChange } from '../modules/auth/sub-pages/VerifyOrgEmailChange'
import DownloadRedirect from '../pages/DownloadRedirect'


// When a logged-out user hits a protected deep link (e.g. the founding-member
// checkout link from the email), stash where they were headed before bouncing
// them to the login page, so we can return them there after they sign in.
const RedirectToAuth: FC = () => {
  const { pathname, search } = useLocation()
  useEffect(() => {
    const target = `${pathname}${search}`
    if (pathname && !pathname.startsWith('/auth') && pathname !== '/' && pathname !== '/logout') {
      sessionStorage.setItem('postLoginRedirect', target)
    }
  }, [pathname, search])
  return <Navigate to='/auth' replace />
}

// After login (currentUser becomes available), if we stashed a destination,
// navigate there instead of leaving the user on /auth (which 404s once
// authenticated). Runs once and clears the stash.
const PostLoginRedirect: FC = () => {
  const { currentUser } = useAuth()
  const navigate = useNavigate()
  useEffect(() => {
    if (!currentUser) return
    const stored = sessionStorage.getItem('postLoginRedirect')
    if (stored) {
      sessionStorage.removeItem('postLoginRedirect')
      sessionStorage.removeItem('planGrantEmail')
      navigate(stored, { replace: true })
    }
  }, [currentUser, navigate])
  return null
}

const AppRoutes: FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const { currentUser } = useAuth()
  const handleLogout = () => {
    setIsLoggedIn(false);
    // Perform any additional logout tasks
  };

  return (
    <>
      {/* <BrowserRouter basename={PUBLIC_URL}> */}
      <LogoutListener onLogout={handleLogout} />
      <BrowserRouter>
        <PostLoginRedirect />
        <Routes>
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            <Route path='logout' element={<Logout />} />
            <Route path='organization-email-change/verify' element={<VerifyOrgEmailChange />} />
            <Route path='download' element={<DownloadRedirect />} />
            {currentUser && isLoggedIn ? (
              <>
                <Route path='/*' element={<PrivateRoutes />} />
                <Route index element={<Navigate to='/home' />} />
              </>
            ) : (
              <>
                <Route path='auth/*' element={<AuthPage />} />
                <Route path='*' element={<RedirectToAuth />} />
              </>
            )}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export { AppRoutes }
